module.exports = __webpack_public_path__ + "img/damInflatedDanger.f3699d24.svg";